export const DOMAIN_ROUTES = {
  source: "/ywhc/source",
  grid: "/electricityHome",
  load: "/ywhc/load",
  storage: "/ywhc/storage",
};

export const DOMAIN_NAV = [
  { key: "source", name: "源侧发电", en: "SOURCE" },
  { key: "grid", name: "网侧配电", en: "GRID" },
  { key: "load", name: "荷侧负荷", en: "LOAD" },
  { key: "storage", name: "储侧储能", en: "STORAGE" },
];

const sourceStations = [
  {
    id: "bj-rooftop",
    domain: "source",
    name: "北京调度中心屋顶光伏",
    status: "正常",
    value: "428 kW",
    metrics: { capacity: "1.28 MWp", today: "2.19 MWh", pr: "86.4%", forecast: "+4.2%" },
    scene: "roof-pv",
    devices: [
      { id: "wind-01", type: "wind", name: "示范风机 WTG-01", status: "正常", modelNode: "wind-turbine", metrics: { power: "236 kW", windSpeed: "6.8 m/s", direction: "西北", availability: "99.1%" }, trends: [82, 116, 158, 236, 212, 146], alarms: [] },
      { id: "pv-array-a", type: "pv", name: "屋顶组件 A 区", status: "正常", modelNode: "pv-field", metrics: { power: "156 kW", voltage: "812 V", temperature: "41.6℃", efficiency: "97.2%" }, trends: [42, 88, 126, 156, 148, 92], alarms: [] },
      { id: "inv-bj-03", type: "inverter", name: "逆变器 INV-BJ-03", status: "正常", modelNode: "inverter", metrics: { power: "92 kW", dcVoltage: "813 V", temperature: "47.2℃", efficiency: "98.1%" }, trends: [24, 46, 70, 92, 86, 51], alarms: [] },
      { id: "meter-bj-01", type: "meter", name: "并网表 BJ-01", status: "正常", modelNode: "grid-point", metrics: { power: "428 kW", voltage: "10.08 kV", factor: "0.98", frequency: "50.02 Hz" }, trends: [116, 228, 362, 428, 406, 248], alarms: [] },
    ],
  },
  {
    id: "tj-carport",
    domain: "source",
    name: "天津滨海车棚光伏",
    status: "正常",
    value: "312 kW",
    metrics: { capacity: "0.96 MWp", today: "1.64 MWh", pr: "82.1%", forecast: "-5.8%" },
    scene: "carport-pv",
    devices: [
      { id: "pv-carport-a", type: "pv", name: "车棚组件一区", status: "正常", modelNode: "pv-field", metrics: { power: "168 kW", voltage: "784 V", temperature: "43.1℃", efficiency: "96.8%" }, trends: [38, 82, 126, 168, 151, 78], alarms: [] },
      { id: "inv-tj-06", type: "inverter", name: "逆变器 INV-TJ-06", status: "关注", modelNode: "inverter", metrics: { power: "76 kW", dcVoltage: "779 V", temperature: "54.6℃", efficiency: "95.9%" }, trends: [18, 36, 58, 76, 63, 31], alarms: ["直流侧温升关注"] },
    ],
  },
  {
    id: "ts-ground",
    domain: "source",
    name: "唐山地面光伏示范区",
    status: "关注",
    value: "188 kW",
    metrics: { capacity: "0.54 MWp", today: "0.76 MWh", pr: "78.2%", forecast: "-9.6%" },
    scene: "ground-pv",
    devices: [
      { id: "inv-ts-08", type: "inverter", name: "逆变器 INV-TS-08", status: "关注", modelNode: "inverter", metrics: { power: "41 kW", dcVoltage: "746 V", temperature: "56.8℃", efficiency: "94.2%" }, trends: [9, 18, 33, 41, 28, 12], alarms: ["通信质量偏低", "温升待复核"] },
      { id: "combiner-ts-03", type: "combiner", name: "汇流箱 TS-03", status: "关注", modelNode: "combiner", metrics: { current: "286 A", voltage: "752 V", temperature: "48.2℃", branches: "15/16" }, trends: [126, 168, 214, 286, 232, 152], alarms: ["3# 支路电流偏低"] },
    ],
  },
];

const loadStations = [
  {
    id: "bj-charge",
    domain: "load",
    name: "北京调度中心充电区",
    status: "正常",
    value: "1.08 MW",
    metrics: { peak: "1.42 MW", today: "8.62 MWh", adjustable: "260 kW", rate: "82%" },
    scene: "charging-campus",
    devices: [
      { id: "fast-charge-a", type: "charger", name: "快充区 A", status: "正常", modelNode: "charge-zone", metrics: { power: "680 kW", online: "42/44", utilization: "78%", queue: "6" }, trends: [210, 286, 420, 680, 612, 380], alarms: [] },
      { id: "office-hvac", type: "hvac", name: "综合楼空调系统", status: "正常", modelNode: "office", metrics: { power: "118 kW", supply: "7.2℃", return: "12.6℃", cop: "4.8" }, trends: [42, 58, 82, 118, 106, 76], alarms: [] },
      { id: "lighting-loop", type: "lighting", name: "场区照明回路", status: "正常", modelNode: "workshop", metrics: { power: "36 kW", loops: "18/18", illuminance: "286 lx", strategy: "自动" }, trends: [16, 18, 22, 28, 36, 31], alarms: [] },
    ],
  },
  {
    id: "tj-office",
    domain: "load",
    name: "天津滨海办公楼",
    status: "正常",
    value: "286 kW",
    metrics: { peak: "360 kW", today: "2.19 MWh", adjustable: "76 kW", rate: "72%" },
    scene: "office-campus",
    devices: [
      { id: "office-main", type: "building", name: "办公楼主表", status: "正常", modelNode: "office", metrics: { power: "286 kW", voltage: "381 V", factor: "0.96", intensity: "58 W/㎡" }, trends: [62, 98, 168, 286, 248, 122], alarms: [] },
      { id: "elevator-drive", type: "drive", name: "电梯动力", status: "正常", modelNode: "office", metrics: { power: "32 kW", trips: "186", standby: "4.2 kW", recovery: "12%" }, trends: [8, 12, 21, 32, 24, 11], alarms: [] },
    ],
  },
  {
    id: "sjz-hvac",
    domain: "load",
    name: "石家庄空调机房",
    status: "关注",
    value: "452 kW",
    metrics: { peak: "620 kW", today: "3.42 MWh", adjustable: "142 kW", rate: "91%" },
    scene: "hvac-campus",
    devices: [
      { id: "chiller-01", type: "chiller", name: "冷机 01", status: "关注", modelNode: "hvac", metrics: { power: "228 kW", supply: "8.6℃", return: "14.8℃", cop: "3.2" }, trends: [86, 122, 176, 228, 214, 158], alarms: ["供水温度越限"] },
      { id: "fresh-air", type: "fan", name: "新风机组", status: "正常", modelNode: "hvac", metrics: { power: "38 kW", frequency: "42 Hz", airflow: "18.6 km³/h", filter: "72%" }, trends: [18, 22, 28, 38, 36, 24], alarms: [] },
    ],
  },
];

const storageStations = [
  {
    id: "bj-bess",
    domain: "storage",
    name: "北京调度中心储能舱",
    status: "正常",
    value: "SOC 68%",
    metrics: { capacity: "2.0 MWh", power: "-180 kW", soc: "68%", soh: "97.2%", spread: "3.6℃" },
    scene: "bess-a",
    devices: [
      { id: "rack-a03", type: "battery", name: "电池机架 A03", status: "正常", modelNode: "battery-racks", metrics: { soc: "69%", soh: "97.4%", voltage: "716 V", temperature: "29.8℃" }, trends: [64, 65, 66, 67, 68, 69], alarms: [] },
      { id: "bms-a", type: "bms", name: "BMS-A", status: "正常", modelNode: "bms", metrics: { online: "128/128", maxCell: "3.428 V", minCell: "3.402 V", balance: "运行" }, trends: [18, 21, 19, 23, 20, 22], alarms: [] },
      { id: "pcs-a", type: "pcs", name: "PCS-A", status: "正常", modelNode: "pcs", metrics: { power: "-180 kW", dcVoltage: "718 V", efficiency: "97.6%", temperature: "42.1℃" }, trends: [-80, -120, -180, -160, 80, 126], alarms: [] },
      { id: "fire-a", type: "fire", name: "消防联动主机", status: "正常", modelNode: "fire", metrics: { smoke: "正常", gas: "正常", pressure: "5.8 MPa", mode: "自动" }, trends: [0, 0, 0, 0, 0, 0], alarms: [] },
    ],
  },
  {
    id: "tj-bess",
    domain: "storage",
    name: "天津滨海储能站",
    status: "正常",
    value: "SOC 54%",
    metrics: { capacity: "1.2 MWh", power: "-160 kW", soc: "54%", soh: "96.1%", spread: "3.9℃" },
    scene: "bess-b",
    devices: [
      { id: "pcs-01", type: "pcs", name: "PCS-01", status: "正常", modelNode: "pcs", metrics: { power: "-160 kW", dcVoltage: "704 V", efficiency: "97.1%", temperature: "44.2℃" }, trends: [-60, -110, -160, -120, 60, 98], alarms: [] },
      { id: "rack-b02", type: "battery", name: "电池机架 B02", status: "正常", modelNode: "battery-racks", metrics: { soc: "55%", soh: "96.3%", voltage: "702 V", temperature: "30.6℃" }, trends: [50, 51, 52, 53, 54, 55], alarms: [] },
    ],
  },
  {
    id: "sjz-bess",
    domain: "storage",
    name: "石家庄储能站",
    status: "关注",
    value: "SOC 72%",
    metrics: { capacity: "1.0 MWh", power: "待机", soc: "72%", soh: "95.4%", spread: "6.8℃" },
    scene: "bess-c",
    devices: [
      { id: "bms-01", type: "bms", name: "BMS-01", status: "关注", modelNode: "bms", metrics: { online: "96/96", maxCell: "3.442 V", minCell: "3.381 V", balance: "限制" }, trends: [31, 36, 42, 48, 56, 68], alarms: ["簇间温差偏高", "单体压差待复核"] },
      { id: "rack-c03", type: "battery", name: "电池机架 C03", status: "关注", modelNode: "battery-racks", metrics: { soc: "74%", soh: "94.8%", voltage: "711 V", temperature: "36.8℃" }, trends: [29, 31, 32, 34, 35, 37], alarms: ["最高温度越限"] },
    ],
  },
];

const gridStations = [
  {
    id: "grid-jjj-01",
    domain: "grid",
    name: "京津冀示范配电站",
    status: "正常",
    value: "8.36 MW",
    metrics: { capacity: "20 MVA", load: "8.36 MW", factor: "0.97", quality: "99.8%" },
    scene: "single-line",
    devices: [
      { id: "main-transformer-01", type: "transformer", name: "1# 主变", status: "正常", modelNode: "main-transformer", metrics: { load: "62.8%", power: "6.28 MW", temperature: "58.6℃", voltage: "10.12 kV" }, trends: [42, 48, 51, 58, 63, 62], alarms: [] },
      { id: "feeder-101", type: "feeder", name: "101 馈线", status: "正常", modelNode: "feeder-101", metrics: { current: "286 A", load: "72%", voltage: "10.08 kV", loss: "1.8%" }, trends: [168, 192, 226, 286, 262, 214], alarms: [] },
      { id: "feeder-102", type: "feeder", name: "102 馈线", status: "关注", modelNode: "feeder-102", metrics: { current: "318 A", load: "84%", voltage: "10.04 kV", loss: "2.4%" }, trends: [188, 226, 274, 318, 306, 248], alarms: ["负载率接近关注阈值"] },
      { id: "quality-meter-01", type: "meter", name: "电能质量监测 01", status: "正常", modelNode: "quality-meter", metrics: { frequency: "50.02 Hz", thd: "1.8%", factor: "0.97", unbalance: "0.7%" }, trends: [1.2, 1.4, 1.3, 1.8, 1.6, 1.5], alarms: [] },
    ],
  },
];

export const DEMO_STATIONS = {
  source: sourceStations,
  load: loadStations,
  storage: storageStations,
  grid: gridStations,
};

export function getStations(domain) {
  return DEMO_STATIONS[domain] || [];
}

export function getStation(domain, stationId) {
  return getStations(domain).find((item) => item.id === stationId) || getStations(domain)[0] || null;
}

export function getDevice(domain, stationId, deviceId) {
  const station = getStation(domain, stationId);
  return station ? station.devices.find((item) => item.id === deviceId) || station.devices[0] || null : null;
}
